<script setup lang="ts">
// import { useDateFormat } from '@vueuse/core';
import { storeToRefs } from "pinia";
const messageStore = useMessageStore();
const { title, message, community, saibamais } = storeToRefs(messageStore);

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
});

function close() {
  messageStore.toggleMessageModal();
}
</script>

<template>
  <div v-if="open" class="modal">
    <div class="modal-backdrop" @click="close()"></div>
    <div class="pop-up-window">
      <div class="label">
        <div class="headline-1">{{ title }}</div>
        <div class="content-text">
          {{ message }}
        </div>
      </div>
      <div class="buttons" v-if="community">
        <a class="btn btn-primary-outline lg mt-3" @click="close">
          Conhecer o Community+
        </a>
        <div class="buttons3">
          <a class="btn lg button2" @click="close"> Cancelar </a>
        </div>
      </div>
      <div class="buttons-row" v-if="saibamais">
        <a class="btn lg buttons3 col-6 button2" @click="close"> Saiba mais </a>
        <a class="btn lg buttons3 col-6 button2" @click="close"> OK </a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modal {
  position: fixed;
  display: block;
  width: 100%;
  height: 100vh;
}
.modal-backdrop {
  position: fixed;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  height: 100vh;
  z-index: 1;
  left: 0;
  top: 0;
  display: block;
}

.pop-up-window,
.pop-up-window * {
  box-sizing: border-box;
}
.pop-up-window {
  background: var(--modal-user-bg);
  border-style: solid;
  border-color: var(--neutral-600, #555555);
  border-width: 1px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  width: 360px;
  margin: auto;
  margin-top: 200px;
  position: relative;
  z-index: 999;
}
.label {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.headline-1 {
  color: var(--card-article-title);
  text-align: center;
  font: var(--h-4, 600 18px/26px "Roboto", sans-serif);
  position: relative;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
}
.content-text {
  color: var(--card-article-title);
  text-align: center;
  font: var(--body-2, 400 14px/20px "Roboto", sans-serif);
  position: relative;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
}
.buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.buttons-row {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.buttons2 {
  border-style: solid;
  border-color: var(--darkcommunity-component-primary-stroke, #64d8ff);
  border-width: 1px;
  padding: 0px 12px 0px 12px;
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  height: 44px;
  position: relative;
}

.btn-primary-outline {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 44px;
  padding: 0px 12px 0px 12px;
  border: 1px solid var(--ck-highlight-marker-blue);
  font-family:
    "Roboto",
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    "Open Sans",
    "Helvetica Neue",
    sans-serif;
  font-weight: 400;
  color: var(--active);
  gap: 0px;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;

  &:hover,
  &.active,
  &:focus,
  &:focus-visible {
    background: var(--ck-highlight-marker-blue);
  }
}
.button {
  color: var(--darkcommunity-content-text-active, #ffffff);
  text-align: left;
  font: var(--button-md, 400 16px/24px "Roboto", sans-serif);
  position: relative;
}
.buttons3 {
  background: var(--card-article-bg);
  padding: 0px 12px 0px 12px;
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 44px;
  position: relative;
}
.button2 {
  color: var(--darkcommunity-content-primary, #64d8ff);
  text-align: left;
  font: var(--button-md, 400 16px/24px "Roboto", sans-serif);
  position: relative;
}
</style>
